/**
 * ボトムシート（M1.9・D-99）＝スマホは下から出る紙・PC は中央のモーダル。
 *
 * ★ConfirmDialog（kit.tsx）と同じ作法＝`role="dialog"`・scrim タップと×で閉じる・
 *   モーダル層の影。**確認ダイアログと別部品にする**のは、シートは「読む・選ぶ」の器で
 *   確定ボタン2択の型（ConfirmDialog）に嵌めると中身が全部 body 扱いになるため。
 * ★開いている間は背景をスクロールさせない（後ろが動くと「2枚の紙」の感覚が壊れる）。
 * ★アニメーションは CSS（`.kz-sheet`・liff.css）＝`prefers-reduced-motion` で止まる（D-94）。
 */

import { useEffect, type ReactNode } from "react";

export function Sheet({
  label,
  onClose,
  children,
  testId,
  dismissable = true,
}: {
  label: string;
  onClose: () => void;
  children: ReactNode;
  testId?: string;
  /** false＝背景タップ・×で閉じない（発注完了シート＝Design の done と同じ。ボタンでだけ抜ける）。 */
  dismissable?: boolean;
}) {
  // 背景スクロールのロック（開いている間だけ）。複数枚は同時に開かない前提（1画面1判断）。
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={label}
      className="kz-sheet-wrap"
      onClick={(e) => e.target === e.currentTarget && dismissable && onClose()}
    >
      <div className="kz-sheet" data-testid={testId}>
        {dismissable && (
        <button
          type="button"
          onClick={onClose}
          aria-label="閉じる"
          className="kz-pressable"
          data-testid="sheet-dismiss"
          style={{
            position: "absolute",
            top: 4,
            right: 4,
            width: 44,
            height: 44,
            display: "grid",
            placeItems: "center",
            border: "none",
            background: "transparent",
            color: "var(--kz-color-ink-muted)",
            fontSize: 20,
            cursor: "pointer",
            zIndex: 1,
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.2}
            strokeLinecap="round"
            aria-hidden="true"
          >
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
        )}
        {children}
      </div>
    </div>
  );
}
